import e from"./PoweredBy.vue_vue&type=script&lang.js";import{render as r}from"./PoweredBy.vue_vue&type=template&id=1cd6879e&lang.js";e.render=r;export default e;
//# sourceMappingURL=PoweredBy.vue.js.map
